/// <amd-module name="Wiki/HeaderMetaData/HeaderMetaDataActionCreator" />

import { ITfsPageService } from "Tfs/Platform/Page";
import { IVssPageContext } from "VSS/Platform/Context";
import * as VC_Contracts from "Wiki/Clients/VC/Contracts/Git";
import { HeaderMetaDataSource } from "Wiki/HeaderMetaData/HeaderMetaDataSource";
import { HeaderMetaDataActions, HeaderMetaDataStore } from "Wiki/HeaderMetaData/HeaderMetaDataStore";
import { IHeaderMetaDataActionCreator } from "Wiki/HeaderMetaData/Interfaces/IHeaderMetaDataTypes";

export class HeaderMetaDataActionCreator implements IHeaderMetaDataActionCreator {
    private _source: HeaderMetaDataSource;
    private _projectId: string | undefined;
    constructor(
        private _actions: HeaderMetaDataActions,
        private _store: HeaderMetaDataStore,
        pageContext: IVssPageContext,
        source?: HeaderMetaDataSource // passing optional source for UTs
    ) {
        const tfsPageData = pageContext.getService<ITfsPageService>("ITfsPageService").getData();
        this._projectId = tfsPageData && tfsPageData.project && tfsPageData.project.id;
        this._source = source || new HeaderMetaDataSource(pageContext);
    }

    public fetchPageMetaData = (
        repositoryId: string,
        version: VC_Contracts.GitVersionDescriptor,
        gitItemPath: string,
        pagePath: string,
        wikiId: string
    ): void => {
        this._actions.headerMetadataFetchingStarted.invoke({ gitItemPath, pagePath });
        this.fetchLastCommitData(repositoryId, version, gitItemPath);
        this.fetchLinkedWorkItems(pagePath, wikiId);
    };

    public fetchLastCommitData = (repositoryId: string, version: VC_Contracts.GitVersionDescriptor, gitItemPath: string): void => {
        if (this._projectId) {
            this._source.getCommitsData(version, gitItemPath, this._projectId, repositoryId).then((results: VC_Contracts.GitCommitRef[]) => {
                this._actions.commitsDataFetched.invoke(results);
            });
        }
    };

    public fetchLinkedWorkItems = (pagePath: string, wikiId: string): void => {
        if (this._projectId) {
            this._source.getLinkedWorkItems(this._projectId, pagePath, wikiId).then((results: number[]) => {
                if (this._store.getState().pagePath === pagePath) {
                    this._actions.linkedWitDataFetched.invoke(results);
                }
            });
        }
    };

    public clearPageMetadata = (): void => {
        this._actions.clearPageMetadata.invoke();
    };
}
